// src/pages/BorealisPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const BorealisPage = () => {
  const buttonStyle = {
    primary: {
      padding: '15px 30px',
      backgroundColor: '#00d2ff',
      color: '#050a14',
      fontWeight: 'bold',
      textDecoration: 'none',
      borderRadius: '4px',
      fontSize: '1rem',
      border: 'none',
      cursor: 'pointer',
      transition: '0.3s',
      display: 'inline-block'
    },
    secondary: {
      padding: '15px 30px',
      backgroundColor: 'transparent',
      color: '#00d2ff',
      fontWeight: 'bold',
      textDecoration: 'none',
      borderRadius: '4px',
      fontSize: '1rem',
      border: '2px solid #00d2ff',
      cursor: 'pointer',
      display: 'inline-block'
    }
  };

  const sectionStyle = {
    padding: '80px 20px',
    borderBottom: '1px solid #1e293b'
  };

  const headingStyle = {
    fontSize: '2rem',
    marginBottom: '20px',
    color: '#f0f4f8'
  };

  const textStyle = {
    fontSize: '1.1rem',
    lineHeight: '1.6',
    color: '#cbd5e1'
  };

  const cardStyle = {
    background: '#1f2937',
    padding: '30px',
    borderRadius: '8px',
    width: '300px',
    textAlign: 'left',
    border: '1px solid #374151'
  };

  const iconStyle = {
    fontSize: '2.5rem',
    marginBottom: '15px'
  };

  const badgeContainerStyle = {
    marginTop: '20px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px'
  };

  const roleBadgeStyle = {
    fontSize: '0.75rem',
    background: 'rgba(0, 210, 255, 0.15)',
    color: '#00d2ff',
    padding: '4px 8px',
    borderRadius: '4px',
    border: '1px solid rgba(0, 210, 255, 0.3)'
  };

  return (
    <div className="borealis-container" style={{ backgroundColor: '#0b1021', color: '#e0e6ed', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>
      
      {/* HERO SECTION */}
      <header style={{ 
        padding: '100px 20px', 
        textAlign: 'center', 
        background: 'linear-gradient(180deg, #050a14 0%, #0b1021 100%)',
        borderBottom: '1px solid #2a3b55'
      }}>
        <h1 style={{ fontSize: '3.5rem', color: '#00d2ff', marginBottom: '20px', fontWeight: '800' }}>PROJECT BOREALIS</h1>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '300', maxWidth: '800px', margin: '0 auto 40px' }}>
          Strategic Arctic Industrial & Logistics Initiative
        </h2>
        <p style={{ fontSize: '1.2rem', color: '#aab4be', marginBottom: '50px' }}>
          Unlocking the North. Empowering the Future. Built by the Minds We Train.
        </p>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
         {/* UPDATE THIS LINK */}
  <Link to="/borealis/data-room" style={buttonStyle.primary}>
    Access Investor Data Room
  </Link>
  
  <Link to="/pricing" style={buttonStyle.secondary}>
    Train for the Future
  </Link>
        </div>
      </header>

      {/* VISION SECTION: The National Idea */}
      <section style={sectionStyle}>
        <div style={{ maxWidth: '1000px', margin: '0 auto', textAlign: 'center' }}>
          <h3 style={headingStyle}>The Northern Crucible of Innovation</h3>
          <p style={textStyle}>
            Project Borealis is not just infrastructure; it is a flagship initiative embodying a new national idea. 
            We are building a 7000km railway corridor and an integrated industrial cluster to secure economic 
            sovereignty and foster sustainable growth.
          </p>
        </div>
      </section>

      {/* THREE PILLARS */}
      <section style={{ ...sectionStyle, background: '#111827' }}>
        <h3 style={{ ...headingStyle, textAlign: 'center' }}>The Three Pillars</h3>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '30px', marginTop: '40px' }}>
          
          {/* Pillar 1: Logistics */}
          <div style={cardStyle}>
            <div style={iconStyle}>🚂</div>
            <h4 style={{ color: 'white', fontSize: '1.25rem', marginBottom: '10px' }}>Integrated Logistics</h4>
            <p style={{ fontSize: '0.9rem', color: '#b0b8c4' }}>
              A meridional trans-Canada railway combined with Zeppelin pilotless technology and drone systems for essential supply transport.
            </p>
            <div style={badgeContainerStyle}>
              <span style={roleBadgeStyle}>Logistics Grads</span>
              <span style={roleBadgeStyle}>Aviation Grads</span>
            </div>
          </div>

          {/* Pillar 2: Industry */}
          <div style={cardStyle}>
            <div style={iconStyle}>🏭</div>
            <h4 style={{ color: 'white', fontSize: '1.25rem', marginBottom: '10px' }}>Advanced Industry</h4>
            <p style={{ fontSize: '0.9rem', color: '#b0b8c4' }}>
              State-of-the-art iron ore processing, sinter plants, and future green data centers leveraging the Arctic climate.
            </p>
            <div style={badgeContainerStyle}>
              <span style={roleBadgeStyle}>Mining Grads</span>
              <span style={roleBadgeStyle}>Oil & Gas Grads</span>
            </div>
          </div>

          {/* Pillar 3: Living */}
          <div style={cardStyle}>
            <div style={iconStyle}>🏙️</div>
            <h4 style={{ color: 'white', fontSize: '1.25rem', marginBottom: '10px' }}>Sustainable Living</h4>
            <p style={{ fontSize: '0.9rem', color: '#b0b8c4' }}>
              Modular Arctic cities designed for harsh climates, serving as a blueprint for future space exploration infrastructure.
            </p>
            <div style={badgeContainerStyle}>
              <span style={roleBadgeStyle}>Construction Partners</span>
              <span style={roleBadgeStyle}>Medical Grads</span>
            </div>
          </div>

        </div>
      </section>

      {/* INVESTMENT DATA */}
      <section style={sectionStyle}>
        <div style={{ maxWidth: '800px', margin: '0 auto', textAlign: 'center' }}>
          <h3 style={headingStyle}>Investment Scale</h3>
          <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '40px', flexWrap: 'wrap', gap: '20px' }}>
            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#00d2ff' }}>~$53B+</div>
              <div style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Est. Initial CapEx</div>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#00d2ff' }}>5-10 Yrs</div>
              <div style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Phase 1 Development</div>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#00d2ff' }}>7000km</div>
              <div style={{ fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '1px' }}>Strategic Rail Corridor</div>
            </div>
          </div>
          <div style={{ marginTop: '50px' }}>
             <p style={{ fontStyle: 'italic', marginBottom: '30px', color: '#aab4be' }}>
               "For investors, Borealis represents a unique opportunity to be part of a nation-building project with significant long-term returns."
             </p>
             <a href="https://drive.google.com/drive/folders/1lZKxKrKR42itZ68sC1wT48kVP-orLuOC?usp=sharing" target="_blank" rel="noreferrer" style={buttonStyle.primary}>
                Open Data Room
             </a>
          </div>
        </div>
      </section>

      {/* WORKFORCE CONNECTION */}
      <section style={{ ...sectionStyle, background: 'linear-gradient(180deg, #111827 0%, #050a14 100%)', textAlign: 'center' }}>
        <h3 style={headingStyle}>Built by Aulice Academy</h3>
        <p style={{ ...textStyle, maxWidth: '700px', margin: '0 auto 40px' }}>
          We don't just plan infrastructure; we build the human capital required to operate it. 
          Our educational model moves beyond traditional training to equip the workforce of the AI age.
        </p>
        <Link to="/pricing" style={buttonStyle.secondary}>
          View Relevant Courses
        </Link>
      </section>

      {/* FOOTER EMBED */}
      <section style={{ padding: '40px 20px', textAlign: 'center', borderTop: '1px solid #2a3b55' }}>
        <p style={{color: '#aab4be'}}>Watch the Vision</p>
        <div style={{ marginTop: '20px' }}>
           <a href="https://www.youtube.com/@Borealis-u4p" target="_blank" rel="noreferrer" style={{ color: '#00d2ff', textDecoration: 'none', fontSize: '1.2rem' }}>
             Visit the Project Borealis YouTube Channel &rarr;
           </a>
        </div>
      </section>
    </div>
  );
};

export default BorealisPage;